document.addEventListener("DOMContentLoaded", () => {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      // Prevent normal submission
      event.preventDefault();

      try {
        // Submit form with ajax
        await fetch("/cart/add", {
          method: "post",
          body: new FormData(form),
        });

        // Get new cart object
        const res = await fetch("/cart.json");
        const cart = await res.json();

        // Update cart count
        document.querySelectorAll(".cart-count").forEach((el) => {
          el.textContent = cart.item_count;
        });

        const button = form.querySelector('.add-to-cart-btn');
        // Change button text to check mark
        button.value = '✓';
        button.classList.add('added');
        // Remove check mark after 3 seconds
        setTimeout(() => {
            button.classList.remove('added');
            button.value = '+';
        }, 3000);
        
      } catch (error) {
        console.error("Error during AJAX submission:", error);
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function() {
    const isMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const addToCartBtns = document.querySelectorAll('.add-to-cart-btn');

    addToCartBtns.forEach(function(addToCartBtn) {
        const originalSrc = addToCartBtn.src;
        const hoverSrc = 'https://cdn.shopify.com/s/files/1/0533/2202/3075/files/add-to-cart-white.svg';
        let isClicked = false;

        if (isMobileOrTablet) {
            // Mobile and Tablet: Change on click
            addToCartBtn.addEventListener('click', function() {
                if (!isClicked) {
                    addToCartBtn.src = hoverSrc;
                    addToCartBtn.style.transition = 'background-color 0.2s';
                    addToCartBtn.style.backgroundColor = '#0055e8';
                    isClicked = true;

                    // Restore after 0.75 seconds
                    setTimeout(function() {
                        addToCartBtn.src = originalSrc;
                        addToCartBtn.style.backgroundColor = '';
                        isClicked = false;
                    }, 750); // 0.75 seconds
                }
            });
        } else {
            // Desktop: Change on hover
            addToCartBtn.addEventListener('mouseover', function() {
                addToCartBtn.src = hoverSrc;
                addToCartBtn.style.transition = 'background-color 0.2s';
                addToCartBtn.style.backgroundColor = '#0055e8';
            });

            addToCartBtn.addEventListener('mouseout', function() {
                addToCartBtn.src = originalSrc;
                addToCartBtn.style.backgroundColor = '';
            });
        }
    });
});





